import { Box, Text } from '@chakra-ui/react';
import { CONNECTIONS, type ConnectionId } from './catalog';

export interface ConnectionBadgeProps {
    id: ConnectionId;
    /** Square size in pixels. */
    size?: number;
}

/**
 * Stand-in mark for a connection: the provider's initials on its brand colour.
 * We have no licensed logos for these platforms, so the initials keep the rows
 * scannable without shipping someone else's artwork.
 */
const ConnectionBadge = ({ id, size = 36 }: ConnectionBadgeProps) => {
    const { badgeText, badgeColor } = CONNECTIONS[id];
    const fontSize = badgeText.length >= 3 ? size * 0.3 : size * 0.4;

    return (
        <Box
            w={`${size}px`}
            h={`${size}px`}
            borderRadius="md"
            bg={badgeColor}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
        >
            <Text fontSize={`${fontSize}px`} color="white" fontWeight="bold" letterSpacing="tight">
                {badgeText}
            </Text>
        </Box>
    );
};

export default ConnectionBadge;
